import { render } from "./alavi.vue?vue&type=template&id=6f9ff06a"
import script from "./alavi.vue?vue&type=script&lang=js"
export * from "./alavi.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/panelapi-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__